// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.eswitch_fpg_web--Disclosure-module--disclosureWrapper--jrU1X_NXqlxR_mkhgfSI h6 {
  font-size: 16px;
  font-weight: 500;
  line-height: 24px;
  color: rgb(56, 72, 92);
}`, "",{"version":3,"sources":["webpack://./src/components/Disclosure/Disclosure.module.scss"],"names":[],"mappings":"AACI;EACI,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,sBAAA;AAAR","sourcesContent":[".disclosureWrapper {\n    h6 {\n        font-size: 16px;\n        font-weight: 500;\n        line-height: 24px;\n        color: rgb(56, 72, 92);\n    }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"disclosureWrapper": `eswitch_fpg_web--Disclosure-module--disclosureWrapper--jrU1X_NXqlxR_mkhgfSI`
};
export default ___CSS_LOADER_EXPORT___;
